var map = {
	"app/settings/settings.module": [
		"./src/app/settings/settings.module.ts",
		"common",
		"app-settings-settings-module"
	],
	"app/shipment/invoice/invoice.module": [
		"./src/app/shipment/invoice/invoice.module.ts",
		"default~app-shipment-invoice-invoice-module~app-shipment-shipments-shipments-module",
		"common",
		"app-shipment-invoice-invoice-module"
	],
	"app/shipment/shipment.module": [
		"./src/app/shipment/shipment.module.ts",
		"common",
		"app-shipment-shipment-module"
	],
	"app/shipment/shipments/shipments.module": [
		"./src/app/shipment/shipments/shipments.module.ts",
		"default~app-shipment-invoice-invoice-module~app-shipment-shipments-shipments-module",
		"common",
		"app-shipment-shipments-shipments-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;